import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  setLanguage = new BehaviorSubject('');

  constructor() { }

  static googleApiObj: object = { // google api key
    apiKey: 'AIzaSyAkNBALkBX7trFQFCrcHO2I85Re2MmzTo8',
      language: 'en',
      libraries: ['places', 'geometry'],
   };

    mapOptions: google.maps.MapOptions = {
      fullscreenControl: true,
      mapTypeControl: true,      
      streetViewControl: false,    
      zoomControl: true          
    };
}
